import { NextSeo } from 'next-seo';

import BlogGalleryPage from '_components/composed/pages/BlogGalleryPage';

export default function BlogGallery() {
  return (
    <>
      <NextSeo title="Small Business Blog" />
      <BlogGalleryPage />
    </>
  );
}
